export default {
  setAdimplencia(state, payload) {
    state.adimplencia = payload
  }
}
